import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>

        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>

        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail130()">2019-01-30<span class="category">評測</span><p class="cool2"></p>全台首發 『莊智淵 15th 限量紀念拍』 試打評測</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail90()">2018-09-07<span class="category">評測</span><p class="cool2"></p>常見品牌的練習球的差異性</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail88()">2018-09-02<span class="category">評測</span><p class="cool2"></p>"Nittaku" Factive Carbon 底板評測</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail84()">2018-08-19<span class="category">評測</span><p class="cool2"></p>"STIGA" AZALEA(杜鵑)OFFENSIVE評測</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail76()">2018-07-19<span class="category">評測</span><p class="cool2"></p>Nostalgic傳奇7 試打，STIGA持續締造不敗神話</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail74()">2018-07-18<span class="category">評測</span><p class="cool2"></p>BUTTERFLY APOLONIA ZLC 底版 試打評測</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail69()">2018-06-24<span class="category">評測</span><p class="cool2"></p>“美津濃“Q系列膠皮再進化，Q4搶先試打實測</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail64()">2018-05-21<span class="category">評測</span><p class="cool2"></p>XIOM BRAVO ABS40+ 三星比賽球實測短評</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail62()">2018-05-15<span class="category">評測</span><p class="cool2"></p>"YASAKA" Alnade底板 獨家試打評論</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail56()">2018-04-22<span class="category">評測</span><p class="cool2"></p>美津濃 Mizuno Fortius FT ver.D 獨家試打評論</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail52()">2018-04-14<span class="category">評測</span><p class="cool2"></p>美津濃 "Mizuno" Carbosonic 底板 獨家實測</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail51()">2018-04-13<span class="category">評測</span><p class="cool2"></p>"Mizuno" GF Pro與Q3 兩款膠皮獨家試打評測</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail42()">2018-03-15<span class="category">評測</span><p class="cool2"></p>"BTY"桌球底板兩大魔王 Boll ALC與Viscaria</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail35()">2018-02-03<span class="category">評測</span><p class="cool2"></p>乒乓之神的終極神器～水滴型瓦木與瓦碳</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail34()">2018-01-12<span class="category">評測</span><p class="cool2"></p>"Nittaku S-cz" 德國製底板試打報告</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail32()">2017-12-25<span class="category">評測</span><p class="cool2"></p>“XIOM OMEGA 7” 開箱試打分享</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail27()">2017-12-16<span class="category">評測</span><p class="cool2"></p>”YASAKA Extra Offensive“ 試打分享</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail21()">2017-11-22<span class="category">評測</span><p class="cool2"></p>"Nittaku Bloodwood"帥氣開箱分享</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail20()">2017-11-14<span class="category">評測</span><p class="cool2"></p>STIGA 北極純木五夾 ARCTIC 開箱體驗</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail15()">2017-10-19<span class="category">評測</span><p class="cool2"></p>"BUTTERFLY INNERFORCE ZLC"評測分享</button><br><br></div>

        <button class="newBtn" (click)="show1()" *ngIf="more1 == false">更多消息</button>

        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail9()">2017-10-06<span class="category">評測</span><p class="cool2"></p>七夾經典"Avalox-AVX P700" 評測分享</button><br><br></div>
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail11()">2017-09-22<span class="category">評測</span><p class="cool2"></p>"STIGA AIROC系列"膠皮實測</button><br><br></div>
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail4()">2017-07-25<span class="category">評測</span><p class="cool2" ></p>XlOM Musa Asia 五夾純木底板評測分享</button><br><br></div>  
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>

       </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class New3Component implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;
  public more1 : boolean = false 


  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }

  show1(){
    this.more1 = true
  }

  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail84(){
    this.router.navigate(['detail84']);
  }
  gotoDetail88(){
    this.router.navigate(['detail88']);
  }
  gotoDetail90(){
    this.router.navigate(['detail90']);
  }
  gotoDetail130(){
    this.router.navigate(['detail130']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}
}



// WEBPACK FOOTER //
// ./src/app/news/new3.component.ts